export default "__VITE_ASSET__D3P4oedo__"